import { TableCell, TableHead, TableRow, TableSortLabel } from "@mui/material";
import { telemetryProps } from "shared-ui/src/instrumentation/gtm";

export type SortField = "product" | "status" | "unitPrice" | "quantity" | "total";
export type SortDirection = "asc" | "desc";

type ProductTableHeaderProps = {
  sortField: SortField;
  sortDirection: SortDirection;
  onSortHeaderClick: (field: SortField) => void;
  telemetrySection: string;
  showStatusColumn?: boolean;
  showActionsColumn?: boolean;
};

export function ProductTableHeader({
  sortField,
  sortDirection,
  onSortHeaderClick,
  telemetrySection,
  showStatusColumn = true,
  showActionsColumn = true,
}: Readonly<ProductTableHeaderProps>) {
  const renderSortLabel = (field: SortField, label: string) => (
    <TableSortLabel
      active={sortField === field}
      direction={sortField === field ? sortDirection : "asc"}
      onClick={() => onSortHeaderClick(field)}
      {...telemetryProps({
        name: "orders_product_table_sort",
        section: telemetrySection,
        label,
      })}
    >
      {label}
    </TableSortLabel>
  );

  return (
    <TableHead>
      <TableRow sx={{ bgcolor: "action.hover" }}>
        <TableCell
          align="left"
          sortDirection={sortField === "product" ? sortDirection : false}
          sx={{ width: showStatusColumn ? "38.26%" : "44%" }}
        >
          {renderSortLabel("product", "Product")}
        </TableCell>
        {showStatusColumn && (
          <TableCell
            align="left"
            sortDirection={sortField === "status" ? sortDirection : false}
            sx={{ width: "18.78%" }}
          >
            {renderSortLabel("status", "Status")}
          </TableCell>
        )}
        <TableCell
          align="right"
          sortDirection={sortField === "unitPrice" ? sortDirection : false}
          sx={{ width: showStatusColumn ? "10.74%" : "14%" }}
        >
          {renderSortLabel("unitPrice", "Unit Price")}
        </TableCell>
        <TableCell
          align="right"
          sortDirection={sortField === "quantity" ? sortDirection : false}
          sx={{ width: showStatusColumn ? "10.74%" : "12%" }}
        >
          {renderSortLabel("quantity", "Qty")}
        </TableCell>
        <TableCell
          align="right"
          sortDirection={sortField === "total" ? sortDirection : false}
          sx={{ width: showStatusColumn ? "10.74%" : "14%" }}
        >
          {renderSortLabel("total", "Total")}
        </TableCell>
        {showActionsColumn && (
          <TableCell align="left" sx={{ width: showStatusColumn ? "10.74%" : "16%" }}>Actions</TableCell>
        )}
      </TableRow>
    </TableHead>
  );
}
